module.exports = __webpack_public_path__ + "components/breakheader/static/icon--s1-ccfd205b8b428f87c8e056060d9d5aba.svg";